import React, {Component} from 'react';

class Education extends Component {
    render() {
        return (
            <div>
                Education
            </div>
        );
    }
}

export default Education;